import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Thirtinfiveseateronrentinpune() {



  const cardData =
  {
    keyword: '35 Seater Bus On Rent in Pune',
    heading: 'Amruta Travels: 35 Seater Bus On Rent in Pune',
    headingDescription: 'Amruta Travels Pvt. Ltd. offers 35 Seater Bus on Rent in Pune, providing the ideal travel solution for large groups seeking comfort, safety, and convenience. Our 35-seater buses are perfect for corporate trips, school picnics, weddings, religious tours, and outstation journeys, featuring push-back seats, air conditioning, ample legroom, and spacious luggage compartments for a relaxed and enjoyable ride. Each vehicle is maintained to the highest standards and operated by professional chauffeurs who ensure punctuality and smooth travel from start to finish. Whether you’re exploring Pune or traveling to destinations like Mahabaleshwar, Goa, or Shirdi, Amruta Travels’ 35 Seater Bus Rental in Pune guarantees a premium travel experience with reliability, comfort, and affordability combined.',

    top: 'Top Places to Visit in Pune with Amruta Travels',

"topPlaces": [
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is Pune’s most revered spiritual landmark, visited by millions of devotees annually. Its magnificently decorated Lord Ganesha idol radiates devotion and serenity. During Ganesh Chaturthi, the temple comes alive with lights, chants, and celebrations. It stands as Pune’s beacon of faith and divine grace in the heart of the city."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill rises gracefully over Pune, offering a blend of spirituality and scenic beauty. The temple complex atop the hill, dedicated to Lord Shiva and Goddess Parvati, was built by the Peshwas. Climbing its 108 steps rewards visitors with panoramic city views and a peaceful ambiance. Parvati Hill is Pune’s perfect fusion of devotion, history, and natural charm."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched on a rugged hill about 30 km from the city, Sinhagad Fort offers breathtaking views of the Sahyadri ranges. The fort is famed for the heroic battle led by Tanaji Malusare under Chhatrapati Shivaji Maharaj’s command. Visitors enjoy trekking, exploring ancient ruins, and savoring local snacks like pithla-bhakri. Sinhagad Fort embodies Pune’s valor, nature, and nostalgia in one frame."
  },
    {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is an architectural masterpiece and a national monument of India’s freedom movement. Constructed in 1892, it served as a detention site for Mahatma Gandhi and his associates during the Quit India Movement. The palace’s sprawling gardens, museum, and Gandhi memorial exude peace and history. It is Pune’s enduring tribute to the nation’s struggle for independence."
  },
   {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada stands as the crown jewel of Pune’s Maratha heritage, built in 1732 by the Peshwas. Once the seat of the Maratha Empire, it boasts grand gates, intricately carved arches, and sprawling courtyards. The evening light and sound show vividly narrates tales of valor and tragedy. With its rich history and majestic aura, Shaniwar Wada remains the soul of Pune’s cultural identity."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an ancient rock-cut shrine carved out of basalt in the 8th century. Dedicated to Lord Shiva, the temple’s circular Nandi pavilion and stone pillars display remarkable craftsmanship. Nestled in the city center, it provides a tranquil escape from urban life. Pataleshwar Temple connects modern Pune to its timeless spiritual legacy."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure house of over 20,000 rare artifacts collected from across India. From musical instruments to traditional ornaments and sculptures, it offers a fascinating glimpse into India’s past. Each exhibit tells a story of art, culture, and human creativity. It’s a must-visit cultural gem for those exploring Pune’s heritage."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, Osho International Meditation Resort is a serene sanctuary that draws visitors from all over the world. Set amid lush gardens and modern architecture, it offers meditation, wellness programs, and personal growth workshops. The peaceful environment helps people reconnect with their inner selves. Osho Ashram is Pune’s global destination for spirituality and transformation."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a picturesque reservoir surrounded by rolling hills and greenery, just a short drive from Pune. It’s the main water source for the city and a favorite spot for picnics and evening drives. The scenic view of shimmering waters during sunset is mesmerizing. Khadakwasla offers Pune residents the perfect weekend retreat close to nature."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Udyan)",
    "description": "The Pune Okayama Friendship Garden, inspired by Japan’s famous Korakuen Garden, blends Japanese landscaping with Indian flora. Its lush lawns, small bridges, flowing streams, and walking paths create a soothing environment for relaxation. Named after writer Pu La Deshpande, it’s ideal for families and photographers alike. The garden represents Pune’s bond of global friendship and aesthetic beauty."
  }
],



    "services": [
    {
      "name": "Force Urbania 17 Seater On Rent in Pune",
      "description": "Force Urbania 17 Seater On Rent in Pune offers robust and spacious vans ideal for group travel within the city and beyond. These vehicles are well-maintained and regularly serviced to ensure safety and comfort. Suitable for families, corporate groups, and event transportation, the service includes professional drivers experienced with Pune’s traffic, providing punctual pickups and smooth rides. Flexible rental plans accommodate short trips, daily rentals, and long-distance journeys, with transparent pricing and dedicated customer support to deliver a hassle-free booking experience."
    },
    {
      "name": "17 Seater Force Urbania Hire Pune",
      "description": "17 Seater Force Urbania Hire Pune specializes in offering reliable and comfortable Force Urbania vans for groups needing spacious seating and ample luggage capacity. Perfect for corporate outings, family events, and group tours, the service emphasizes vehicle cleanliness, mechanical soundness, and courteous drivers. Customers enjoy flexible scheduling, on-time service, and a user-friendly booking system designed to meet diverse travel requirements throughout Pune."
    },
    {
      "name": "17 Seater Urbania Booking Pune",
      "description": "17 Seater Urbania Booking Pune provides an easy and efficient online platform for reserving Force Urbania vans. Customers can select pickup points, routes, and travel dates with instant confirmation and multiple payment options. The service ensures reliable vehicle availability, timely pickups, and attentive customer care. This streamlined booking process suits busy travelers seeking convenient group transport solutions across Pune."
    },
    {
      "name": "AC 17 Seater Urbania Pune",
      "description": "AC 17 Seater Urbania Pune guarantees a cool, comfortable ride with fully air-conditioned Force Urbania vans, perfect for Pune’s warm climate. These vehicles feature well-maintained interiors, ergonomic seating, and modern AC systems, offering a premium travel experience. Professional drivers prioritize passenger comfort and safety, making this service ideal for airport transfers, corporate events, and leisure trips requiring reliable and stylish transportation."
    },
    {
      "name": "Non AC 17 Seater Urbania Pune",
      "description": "Non AC 17 Seater Urbania Pune caters to budget-conscious customers seeking economical yet dependable group travel within Pune. These vans maintain high standards of cleanliness and safety despite lacking air conditioning, making them a practical choice for short city trips and local commutes. Experienced drivers ensure punctual pickups and smooth rides, delivering value without compromising on reliability."
    },
    {
      "name": "Force Urbania Hire in Hadapsar",
      "description": "Force Urbania Hire in Hadapsar focuses on providing dependable 17 seater vans for residents and businesses in the Hadapsar area. This localized service offers timely pickups, clean vehicles, and professional chauffeurs familiar with the region’s roads. Whether for office commutes, social outings, or airport transfers, customers can expect flexible rental options and excellent support."
    },
    {
      "name": "Force Urbania Hire in Baner",
      "description": "Force Urbania Hire in Baner delivers reliable group transportation solutions tailored to the needs of Baner’s dynamic population. These 17 seater vans are ideal for family outings, corporate events, and local tours. The service prides itself on punctuality, vehicle hygiene, and courteous driver behavior, offering customized travel plans to suit individual client requirements."
    },
    {
      "name": "Force Urbania Hire in Hinjewadi",
      "description": "Force Urbania Hire in Hinjewadi caters primarily to the IT and corporate sectors, providing efficient and comfortable transport for employees and business groups. These 17 seater vans are well-maintained and driven by professionals familiar with Hinjewadi’s traffic patterns, ensuring on-time arrivals and smooth rides for daily commutes, client meetings, and corporate events."
    },
    {
      "name": "Luxury Force Urbania Pune",
      "description": "Luxury Force Urbania Pune offers premium vans featuring upscale interiors, plush seating, and enhanced amenities designed for special occasions such as weddings, VIP travel, and corporate functions. The service provides elegant vehicles, attentive chauffeurs, and personalized touches to create a luxurious and memorable travel experience. Clients benefit from flexible booking, impeccable service, and attention to detail."
    },
    {
      "name": "Force Urbania for Corporate Trips Pune",
      "description": "Force Urbania for Corporate Trips Pune specializes in efficient and professional group transport for businesses. These vans are ideal for employee shuttles, client visits, and corporate events, featuring clean, comfortable interiors and punctual service. Skilled drivers observe corporate standards of conduct and safety, helping companies maintain smooth operations with reliable transportation solutions."
    },
    {
      "name": "Force Urbania for Wedding Pune",
      "description": "Force Urbania for Wedding Pune provides stylish and well-maintained vans for wedding events and related ceremonies. The service includes options for vehicle decoration, timely pickups and drop-offs, and courteous drivers experienced in managing wedding logistics. This service adds convenience and elegance to your special day’s transportation needs."
    },
    {
      "name": "Force Urbania for Outstation Pune",
      "description": "Force Urbania for Outstation Pune caters to groups traveling outside Pune for business trips, leisure tours, and family visits. These 17 seater vans are equipped for long journeys with spacious seating and luggage space, driven by experienced chauffeurs skilled in intercity routes. Safety, punctuality, and comfort are prioritized to ensure a pleasant travel experience."
    },
    {
      "name": "Force Urbania for Shirdi Trip Pune",
      "description": "Force Urbania for Shirdi Trip Pune offers convenient and comfortable transport options for pilgrim groups traveling to Shirdi and nearby religious sites. The service provides well-maintained 17 seater vans, flexible scheduling, and experienced drivers who ensure safe and timely journeys, making spiritual trips hassle-free and enjoyable."
    },
    {
      "name": "Affordable Force Urbania Rental Pune",
      "description": "Affordable Force Urbania Rental Pune focuses on delivering cost-effective van rental options without compromising vehicle quality or service standards. Targeted at budget-conscious travelers, small corporate groups, and families, this service offers transparent pricing, well-maintained vans, and professional drivers to ensure reliable and safe transportation across Pune."
    },
    {
      "name": "Force Urbania Tour Bus Pune",
      "description": "Force Urbania Tour Bus Pune provides specially equipped 17 seater vans designed for sightseeing, group excursions, and leisure travel around Pune and nearby attractions. These vehicles offer comfortable seating, sufficient luggage space, and knowledgeable drivers who often act as local guides, ensuring an informative and enjoyable travel experience tailored to tourists and groups."
    },
    {
      "name": "Force Urbania Hire near Me Pune",
      "description": "Force Urbania Hire near Me Pune ensures quick and localized access to 17 seater Force Urbania vans throughout Pune. This service emphasizes rapid response times, flexible rental durations, and availability of clean, well-maintained vehicles for both immediate and scheduled travel needs. Professional drivers and transparent pricing make group travel convenient and accessible."
    },
    {
      "name": "Force Urbania Daily Rental Pune",
      "description": "Force Urbania Daily Rental Pune offers flexible day-based rental packages suitable for businesses, tourists, and families requiring vans for daily use. The service guarantees reliable vehicles, punctual drivers, and hassle-free booking processes, making it ideal for short-term transportation needs within and around Pune."
    },
    {
      "name": "17 Seater Urbania Van Pune",
      "description": "17 Seater Urbania Van Pune provides versatile and spacious vans perfect for group travel across Pune city. Whether for corporate outings, social events, or airport transfers, these vans combine comfort, safety, and reliability. Regular maintenance, professional chauffeurs, and flexible rental options ensure customer satisfaction and seamless travel experiences."
    }
  ],
  "tableData": [
    ["Force Urbania 17 Seater On Rent in Pune", "17 Seater Force Urbania Hire Pune"],
    ["17 Seater Urbania Booking Pune", "AC 17 Seater Urbania Pune"],
    ["Non AC 17 Seater Urbania Pune", "Force Urbania Hire in Hadapsar"],
    ["Force Urbania Hire in Baner", "Force Urbania Hire in Hinjewadi"],
    ["Luxury Force Urbania Pune", "Force Urbania for Corporate Trips Pune"],
    ["Force Urbania for Wedding Pune", "Force Urbania for Outstation Pune"],
    ["Force Urbania for Shirdi Trip Pune", "Affordable Force Urbania Rental Pune"],
    ["Force Urbania Tour Bus Pune", "Force Urbania Hire near Me Pune"],
    ["Force Urbania Daily Rental Pune", "17 Seater Urbania Van Pune"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Force Urbania 17 Seater On Rent in Pune",
    "WhyChoosedescription": "Amruta Travels Pvt Ltd offers the spacious and premium Force Urbania 17 seater on rent in Pune, ideal for comfortable and stylish group travel."
  },
  {
    "WhyChooseheading": "Modern and Well-Maintained Fleet",
    "WhyChoosedescription": "Our Force Urbania vans are regularly serviced and kept in excellent condition to ensure maximum comfort and reliability."
  },
  {
    "WhyChooseheading": "Honest and Competitive Pricing",
    "WhyChoosedescription": "We provide transparent rental rates with no hidden costs, giving you full value for your money."
  },
  {
    "WhyChooseheading": "Custom Rental Packages",
    "WhyChoosedescription": "Choose from flexible rental options including hourly, daily, or long-distance travel plans suited to your itinerary."
  },
  {
    "WhyChooseheading": "Experienced Drivers for a Smooth Ride",
    "WhyChoosedescription": "Our skilled and professional drivers ensure a safe, timely, and pleasant journey throughout Pune and beyond."
  },
  {
    "WhyChooseheading": "24/7 Customer Service Support",
    "WhyChoosedescription": "Our dedicated support team is available round-the-clock to help with bookings, schedule changes, or special requests."
  },
  {
    "WhyChooseheading": "Simple and Fast Booking Process",
    "WhyChoosedescription": "Book your 17 seater Force Urbania easily online or over the phone, with prompt pickup and vehicle delivery."
  },
  {
    "WhyChooseheading": "Trusted by Hundreds of Happy Customers",
    "WhyChoosedescription": "Amruta Travels Pvt Ltd is known for providing dependable, safe, and luxurious Force Urbania rental services in Pune."
  }
]






















  }

const faqData = [
  {
    question: 'Does Amruta Travels Pvt Ltd offer Force Urbania 17 seater on rent services in Pune?',
    answer: 'Yes, Amruta Travels Pvt Ltd provides Force Urbania 17 seater vehicles on rent in Pune, ideal for medium-sized group travel and events.',
  },
  {
    question: 'How can I book a Force Urbania 17 seater for rent in Pune with Amruta Travels?',
    answer: 'Booking can be done easily through our website, mobile app, or by contacting our 24×7 customer support team in Pune.',
  },
  {
    question: 'What amenities are available in the Force Urbania 17 seater vehicles in Pune?',
    answer: 'Our Force Urbania 17 seater vehicles come with comfortable seating, air conditioning, and essential safety features to ensure a pleasant ride.',
  },
  {
    question: 'Are the drivers trained and experienced for Force Urbania 17 seater hires in Pune?',
    answer: 'Yes, our drivers are professional, courteous, and experienced in safely driving Force Urbania 17 seater vehicles.',
  },
  {
    question: 'Can Force Urbania 17 seater vehicles be hired for weddings, corporate events, and tours in Pune?',
    answer: 'Absolutely. These vehicles are perfect for weddings, corporate outings, airport transfers, and sightseeing tours in Pune.',
  },
  {
    question: 'Is the Force Urbania 17 seater hire service available 24×7 in Pune?',
    answer: 'Yes, Amruta Travels offers 24×7 availability for Force Urbania 17 seater hire services in Pune.',
  },
  {
    question: 'What safety and hygiene measures are followed for Force Urbania 17 seater hires?',
    answer: 'All Force Urbania vehicles are thoroughly sanitized before every trip, and our drivers adhere to strict hygiene and safety protocols.',
  },
  {
    question: 'What are the payment options for Force Urbania 17 seater hire in Pune?',
    answer: 'Payments can be made via UPI, credit/debit cards, digital wallets, and bank transfers for your convenience.',
  },
  {
    question: 'Is customer support available throughout the Force Urbania 17 seater hire period in Pune?',
    answer: 'Yes, our 24×7 customer support team is available to assist you at any time during your rental period.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sameer Deshpande',
    feedback: 'The 17 seater Urbania from Amruta Travels Pune was spacious and comfortable. The driver was punctual and very professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Kavita Joshi',
    feedback: 'Great experience with Amruta Travels. The 17 seater Urbania was perfect for our corporate event in Pune.',
    rating: 5,
  },
];





























































  const Images = [
  { place: "/images/keyword/1.jpg", text: "24 Seater Bus for Rent in Pune", link: "24-seater-bus-for-rent-in-pune" },
  { place: "/images/keyword/2.jpg", text: "16 Seater Urbania for Rent in Pune", link: "16-seater-urbania-for-rent-in-pune" },
  { place: "/images/keyword/3.jpg", text: "14 Seater Urbania Hire in Pune", link: "14-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/4.jpg", text: "17 Seater Urbania Hire in Pune", link: "17-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/5.jpg", text: "Mini Bus On Rent in Pimpri Chinchwad", link: "mini-bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/6.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
  { place: "/images/keyword/7.jpg", text: "Force Urbania 17 Seater On Rent in Pune", link: "force-urbania-17-seater-on-rent-in-pune" },
  { place: "/images/keyword/8.jpg", text: "35 Seater Bus On Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/9.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/10.jpg", text: "53 Seater Bus On Rent in Pune", link: "53-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/11.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/12.jpg", text: "Bus On Rent in Pune", link: "bus-on-rent-in-pune" },
  { place: "/images/keyword/13.jpg", text: "Bus Hire in Pune", link: "bus-hire-in-pune" },
  { place: "/images/keyword/14.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/15.jpg", text: "Bus Rental for Corporate Events in Pune", link: "bus-rental-for-corporate-events-in-pune" },
  { place: "/images/keyword/16.jpg", text: "Wedding Bus Booking Online Pune", link: "wedding-bus-booking-online-pune" },
  { place: "/images/keyword/17.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
  { place: "/images/keyword/18.jpg", text: "Bus Hire for Party Events in Pune", link: "bus-hire-for-party-events-in-pune" },
  { place: "/images/keyword/19.jpg", text: "Full Bus Booking for Marriage Pune", link: "full-bus-booking-for-marriage-pune" },
  { place: "/images/keyword/20.jpg", text: "AC Luxury Bus On Rent in Pune", link: "ac-luxury-bus-on-rent-in-pune" },
  { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
  { place: "/images/keyword/22.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "luxury-force-urbania-on-rent-in-pune" },
  { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Pune for Corporate", link: "urbania-on-rent-in-pune-for-corporate" },
  { place: "/images/keyword/24.jpg", text: "Pune to Goa Urbania On Rent", link: "pune-to-goa-urbania-on-rent" },
  { place: "/images/keyword/25.jpg", text: "Pune to Mumbai Urbania on Rent", link: "pune-to-mumbai-urbania-on-rent" }
];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "35 Seater Bus On Rent in Pune",
  "image": "https://www.amrutatravelspvtltd.com/images/keyword/8.jpg",
  "description": "Book a 35 Seater Bus On Rent in Pune with Amruta Travels Pvt. Ltd. offering spacious, comfortable, and affordable AC, Non-AC, and Luxury buses for corporate events, weddings, school trips, and outstation travel across Maharashtra.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels Pvt. Ltd."
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "14985"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4200",
    "availability": "https://schema.org/InStock",
    "url": "https://www.amrutatravelspvtltd.com/35-seater-bus-on-rent-in-pune"
  }
};




  return (
    <div>
<Helmet>
  <title>35 Seater Bus On Rent in Pune | AC & Luxury Bus Hire | Amruta Travels Pvt. Ltd.</title>
  <meta
    name="description"
    content="Book 35 Seater Bus On Rent in Pune with Amruta Travels Pvt. Ltd. Choose from AC, Non-AC, and Luxury buses for corporate events, weddings, school trips, and outstation travel. Affordable and reliable bus rental in Pune."
  />
  <meta
    name="keywords"
    content="35 Seater Bus On Rent in Pune, 35 Seater AC Bus Pune, 35 Seater Non AC Bus Pune, 35 Seater Bus Hire Pune, 35 Seater Bus Rental Pune, 35 Seater Luxury Bus Pune, 35 Seater Bus Hire in Hadapsar, 35 Seater Bus Hire in Hinjewadi, 35 Seater Bus Hire in Baner, 35 Seater Bus Hire in Pimpri, 35 Seater Bus for Corporate Events Pune, 35 Seater Bus for Wedding Pune, 35 Seater Bus for School Trips Pune, Affordable 35 Seater Bus Pune, 35 Seater Bus Hire near Me Pune, 35 Seater Tourist Bus Pune, 35 Seater Bus for Outstation Pune, 35 Seater Bus Booking Online Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage: "url(/images/page-header-bg-1-1.jpg)",
          }}
        ></div>
        <div className="container">
          <div className="page-header__content">
            <h2 className="page-header__title">   {cardData.keyword}</h2>
          </div>
        </div>
      </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/8.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Amruta Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Amruta Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918010014995" className="pc-call">+91 8010014995</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918010014995"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918010014995" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@amrutatravelspvtltd.com" className="pc-email">
                      booking@amrutatravelspvtltd.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Amruta Travels Pvt Ltd</strong><br />
                      Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Thirtinfiveseateronrentinpune;